module.exports = __webpack_public_path__ + "static/media/iphone13.e78bc9e6.webp";